var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-flex", [
        _c("p", { class: _vm.$modal.modalSmallText }, [
          _vm._v("\n      Please check your email for a link.\n    ")
        ])
      ]),
      _vm._v(" "),
      _c(
        "v-flex",
        { class: _vm.$modal.modalSmallButton },
        [
          _c(
            "BaseButton",
            {
              attrs: { "button-style": "Teal" },
              on: {
                click: function($event) {
                  return _vm.close()
                }
              }
            },
            [_vm._v("OK")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/auth/components/LinkSent.vue?vue&type=template&id=330f8b90&
// module id = null
// module chunks = 